import React, { useEffect, useState } from 'react';

import UserBoardHeader from '@/userBoard/views/UserBoardHeader';
import NavTabs from './NavTabs';
import { NikeRoute } from 'nike-ui/src/common/routing/types';

import '../Lottery.less';
import { useLotteryData, createThumbnailUrl } from 'nike-ui/src/components/lottery/common';
import NuiHeader from 'nike-ui/src/components/nui-header/NuiHeader';
import { throttle } from 'lodash';
import { isProfileIScratchCardEnabled } from 'nike-ui/src/profiles';
import i18n from '@i18n';

interface LotteryHeaderProps {
    active: NikeRoute;
}

const LotteryHeader: React.FC<LotteryHeaderProps> = ({ active }) => {
    const { data } = useLotteryData();
    const [topMenuShadowDisabled, setTopMenuShadowDisabled] = useState(false);

    useEffect(() => {
        const handleLotteryHeaderScroll = throttle(() => {
            if (window.scrollY >= 150 && !topMenuShadowDisabled) {
                setTopMenuShadowDisabled(true);
            }
            if (window.scrollY < 150 && topMenuShadowDisabled) {
                setTopMenuShadowDisabled(false);
            }
        }, 100);

        window.addEventListener('scroll', handleLotteryHeaderScroll);

        return () => {
            window.removeEventListener('scroll', handleLotteryHeaderScroll);
        };
    }, [topMenuShadowDisabled]);

    return (
        <>
            {/* @ts-expect-error typescript */}
            <UserBoardHeader noShadow={topMenuShadowDisabled} />
            <NuiHeader
                title={data?.overview?.header || i18n('nui.scratchcards.title')}
                subTitle={data?.overview?.perex || i18n('nui.scratchcards.description')}
                iconBackground={createThumbnailUrl(data?.overview?.photo)}
            />
            {isProfileIScratchCardEnabled() ? null : <NavTabs active={active} />}
        </>
    );
};

export default LotteryHeader;
